import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { useUpdateBreadcrumb } from "src/hooks/useUpdateBreadcrumb";
import { loaderHandler } from "src/lib/loaderHandler";
import { productQueryOptions } from "src/queries/products";

export const Route = createFileRoute("/_auth/_coach/products/$productId")({
  component: RoutePage,
  ssr: true,
  shouldReload: false,
  async loader({ context, params }) {
    return await loaderHandler(async () => {
      const product = await context.queryClient.query({
        ...productQueryOptions(params.productId),
        staleTime: "static",
      });

      return {
        data: null,
        breadcrumb: {
          id: product.id,
          label: product.name,
          href: `/products/${product.id}`,
        },
      };
    });
  },
});

function RoutePage() {
  const params = Route.useParams();
  const productQuery = useSuspenseQuery(productQueryOptions(params.productId));

  useUpdateBreadcrumb(productQuery.data.id, productQuery.data.name);

  return <Outlet />;
}
